import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService, ModuleType, QuestionType } from '../../API.service';
import { ViewModule, ViewModuleMap } from '../../app.types';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed, void => expanded', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class UserComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute, 
    private api: APIService,
    private router: Router,
    private admin: AdminService
  ) { }
 
  loading: boolean;

  ModuleType = ModuleType;
  QuestionType = QuestionType;
  
  username: string;
  userId: string;
  columnsToDisplay = ['Label', 'Mark', 'MarkPercentage', 'ExpandedIndicator'];

  moduleIDsOrdered: Array<string> = []
  modules: ViewModuleMap = new ViewModuleMap();
  get modulesOrdered() : Array<ViewModule> {
    return this.moduleIDsOrdered.map(m => this.modules.get(m))
  }

  ngOnInit(): void {
    
    this.loading = true;

    this.activatedRoute.params.subscribe(async (params) => {

      this.userId = params["userId"];
      
      var allUsers = await this.admin.getAllUsers();

      this.username = allUsers.filter(u => u.Attributes.filter(a => a.Name == "sub")[0].Value == this.userId )[0].Username

      var modulesNextToken = ""
      var modules = [];

      while (modulesNextToken != null) {
        var user = await this.api.getUserForAdmin(params["userId"], modulesNextToken)
        var modulesNextToken = user.institution.modules.nextToken;
        modules.push(...user.institution.modules.items);
      }

      await Promise.all(modules.map(async (m) => {
        
        var m2 = new ViewModule();
        this.modules.set(m.id, m2);
        await m2.init(allUsers, m)

      }))

      this.sortModulesByLabel();
      
      this.loading = false;
      
    })

  }

  download() {

    // var s = ""

    // this.modules.forEach(module => {

    //   s += `Module: ${module.label}\n\n`

    //   module.questions.forEach((question, i) => {

    //     s += `Question ${i + 1}: ${question.value}\n\n`

    //     if (question.response) {
          
    //       question.response.choices.forEach(c => {
    //         s += `${c.value}\n`
    //       })

    //       if (question.response.value){
    //         s += `${question.response.value.split(/\r?\n/).filter(v => v != "").join("___")}\n`
    //       }
          
    //     } else {

    //       s += 'No Response\n'

    //     }
        
    //     s += '\n'


    //   })

    //   s += '\n'

    // })

    // var blob = new Blob([s], {type: 'text/csv'})

    // saveAs(blob, 'user_responses.csv');

  }

  editModule(moduleId) {
    this.router.navigate(["moduleEdit", moduleId])
  }

  markResponse(response, moduleID, questionID, correct) {
    
    // response.marking = true;

    // this.api.UpdateResponse({
    //   id: response.id,
    //   moduleID: moduleID,
    //   questionID: questionID,
    //   userID: this.userId,
    //   correctness: correct ? 100 : 0 
    // }).then(r => {
    //   response.correct = r.correctness == 100;
    //   response.marking = false;

    //   this.modules

    // })

  }

  sortModules(event){
    switch(event.active) {
      case ("Mark"):
        this.sortModulesByMark(event.direction)
        break;
      case ("Label"):
        this.sortModulesByLabel(event.direction)
        break
    }
  }

  sortModulesByLabel(direction: string = 'asc') {
    this.moduleIDsOrdered = Array.from(this.modules.values()).sort((a, b) => {
      return direction == 'asc' || direction == ''
        ? a.label.localeCompare(b.label)
        : b.label.localeCompare(a.label)
    }).map(m => m.id)
  }

  sortModulesByMark(direction: string = 'asc') {
    this.moduleIDsOrdered = Array.from(this.modules.values()).sort((a,b) => {

      var aMark = a.getMark(this.userId)
      var bMark = b.getMark(this.userId);

      return direction == 'asc' || direction == ''
          ? aMark - bMark
          : bMark - aMark

    }).map(m => m.id)
  }

  scrollTo(module){
    document.querySelector("#module-" + module.id).scrollIntoView({ behavior: "smooth", block: "start" });
  }

}
